import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { UserapiService } from 'src/app/common/userapi.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  arr_banner=[];

  constructor(private user:UserapiService) {
  }

  ngOnInit() {
    this.bindbanner()
    //this.playAudio();
  }


  bindbanner(){

    const OnWebsiteHome=1;
    // console.log(uniqueid)
    this.arr_banner = [];
      this.user.GET("banner_get_websitehome?OnWebsiteHome=" + OnWebsiteHome).then(data => {
     
          //this.formsearchmaster.patchValue({statusid:1});
        this.arr_banner=data
        //console.log(this.arr_banner)
        
      })
  }

  // playAudio() {
  //   const audio = new Audio(this.audioSource);
  //   audio.autoplay = true;
  //   audio.loop = true;

  //   audio.addEventListener('play', () => {
  //     console.log('Audio played successfully');
  //   });

  //   audio.addEventListener('error', (error) => {
  //     console.error('Error playing audio:', error);
  //   });
  // }

  
}
